import req from './request.config.js';
import u from '@/lib/tools.js';


let url = {

}

const reqFiles = require.context('./links', false, /\.js/);
const requireAll = requireContext => {
    requireContext.keys().map(path => {
        let link = requireContext(path).default;
        Object.keys(link).forEach(k => {
            if(url.hasOwnProperty(k)) {
                console.error('接口重复:', k, link[k]);
            } else {
                url[k] = link[k];
            }
        })
    });
    //console.log(url)
};
requireAll(reqFiles);


let service = {
    /*自动生成方法*/


};

u.makeService(url, service, req);

export default service;
